export default __webpack_public_path__ + "static/TV_Frontline-AiStudio_grey_RGB.png";